// The full-screen brand splash shown while the session is still resolving.
//
// Extracted from `AuthGuard` (BL-1109) because there are now two places that
// need it and they must look identical: the `<Suspense>` fallback the server
// layouts wrap `SessionProvider` in, and `AuthGuard`'s own `loading` branch
// (which still fires for consumers rendered outside a provider). Two copies of a
// full-screen splash is exactly the drift `sharing.md` § 4 exists to stop.

import { Spinner } from '@auctogon/ui/web';

/**
 * Full-viewport brand splash with a spinner.
 *
 * @returns the splash element.
 */
export default function SessionSplash() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-primary">
            {/* `text-primary-foreground` (the light green) rather than
                `text-primary`: this splash sits on a dark brand fill, where the
                dark green would vanish. Token, not a hex — BL-1124 AC 2. */}
            <div className="text-center text-primary-foreground">
                <Spinner size="lg" className="mx-auto mb-4" />
                <p className="text-white/80">Loading...</p>
            </div>
        </div>
    );
}
